export function redirectToPage(href: string): void {
    window.location.href = href;
}
